export default __webpack_public_path__ + "static/media/me-dark.d5e0f371.webp";